import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";
import { ComponentProps } from "react";
import { Defined } from "sonobello.utilities.react";

import BaseMedicalQuestion, { IMedicalQuestionConfig } from "./BaseMedicalQuestion";

type YesOrNo = "yes" | "no";

const YesNoToggle = ({ value, onChange }: ComponentProps<Defined<IMedicalQuestionConfig>["FormElement"]>) => {
  const groupValue = (value === null ? undefined : value ? "yes" : "no") as YesOrNo;

  const activeButtonSx = {
    "&.Mui-selected": {
      backgroundColor: "primary.main",
      color: "common.white",
      "&:hover": {
        backgroundColor: "primary.main"
      }
    }
  };

  return (
    <ToggleButtonGroup
      color="primary"
      // value={undefined}
      value={groupValue}
      exclusive
      onChange={(_, newValue) => onChange(newValue === "yes")}
    >
      <ToggleButton className="medicalStep-yesButton" value="yes" sx={activeButtonSx}>
        Yes
      </ToggleButton>
      <ToggleButton className="medicalStep-noButton" value="no" sx={activeButtonSx}>
        No
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

/** An implementation of {@link BaseMedicalQuestion} which uses a Yes/No toggle for its input element. */
const YesNoToggleMedicalQuestion: React.FC<Omit<ComponentProps<typeof BaseMedicalQuestion>, "FormElement">> = props => (
  <BaseMedicalQuestion {...props} FormElement={YesNoToggle} />
);

export default YesNoToggleMedicalQuestion;
